/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_CrossfitInputs */

const en_us2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit`)
};

const pt_br2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit ou cross training`)
};

const es_419_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit o cross training`)
};

const pt_pt2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit ou cross training`)
};

const fr_fr2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit ou cross-training`)
};

const de_de2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit`)
};

const it_it2_modality_crossfit = /** @type {(inputs: Modality_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit o cross training`)
};

/**
* | output |
* | --- |
* | "CrossFit" |
*
* @param {Modality_CrossfitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_crossfit = /** @type {((inputs?: Modality_CrossfitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_CrossfitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_crossfit(inputs)
	if (locale === "es-419") return es_419_modality_crossfit(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_crossfit(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_crossfit(inputs)
	if (locale === "de-DE") return de_de2_modality_crossfit(inputs)
	if (locale === "it-IT") return it_it2_modality_crossfit(inputs)
	return en_us2_modality_crossfit(inputs)
});
export { modality_crossfit as "modality.crossfit" }